import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { Box } from '@chakra-ui/react';
import loadable from 'helpers/lazyWithPreload';

const Account = loadable(() => import('components/account_v2/Account'));

export const AccountRoutes = () => {
  return (
    <Box>
      <Routes>
        <Route element={<Account />} path="/edit" />
        <Route path="*" element={<Navigate replace to="/edit" />} />
      </Routes>
    </Box>
  );
};

export default AccountRoutes;
